module.exports = __webpack_public_path__ + "static/bunnygown-faabdda542efc3c1992a23abf72f240a.jpeg";